import { ChecklistItem } from './Checklistitem';
import { UserTimestamp } from './User';

export class Objecttype {
  public id?: string;
  public name?: string;
  public enName?: string;
  public category?: ObjecttypeCategory;
  public group?: ObjecttypeGroup;
  public subgroup?: ObjecttypeSubgroup;
  public active?: boolean;
  public checklistitems?: ChecklistItem[];
  public editedBy?: UserTimestamp[];
  public missingEn?: boolean;
  public numberOfItemsMissingEn?: number;
  // public category?: string;
}
export class ObjecttypeCategory {
  public id?: string;
  public name?: string;
  public editedBy?: UserTimestamp[];
}
export class ObjecttypeGroup {
  public id?: string;
  public name?: string;
  public categoryid?: string;
  public editedBy?: UserTimestamp[];
}
export class ObjecttypeSubgroup {
  public id?: string;
  public name?: string;
  public groupid?: string;
  public editedBy?: UserTimestamp[];
}
